import { Component, Input } from '@angular/core';

export const States = {
    inherit: 'inherit',
    allow: 'allow',
    deny: 'deny',
};

export type StateType = (typeof States)[keyof typeof States];
export interface Legend {
    type: StateType;
    name: string;
}

/** This component displays the permissions legend used in the list in permissions editor. */
@Component({
    selector: 'cw-permissions-legend',
    templateUrl: './permissions-legend.component.html',
    styleUrls: ['./permissions-legend.component.scss'],
    standalone: false,
})
export class PermissionsLegendComponent {
    /** List of item to be displayed in the component */
    @Input() legendList: Legend[] = [];
}
